import request from '@/utils/request';

export async function save(payload) {
  return request(`/iwms-wms/wms/sense`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveAndAudit(payload) {
  return request(`/iwms-wms/wms/sense/saveAndAudit`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveAndAuditByOrderBillOrInwrh(payload) {
  return request(`/iwms-wms/wms/sense/saveAndAuditByOrderBillOrInwrh`, {
    method: 'POST',
    body: payload,
  });
}

export async function deleteSence(payload) {
  return request(`/iwms-wms/wms/sense/${payload.uuid}?version=${payload.version}`, {
    method: 'DELETE',
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/sense/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function query(payload) {
  return request(`/iwms-wms/wms/sense/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function audit(payload) {
  return request(`/iwms-wms/wms/sense/audit/${payload.uuid}?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function get(uuid) {
  return request(`/iwms-wms/wms/sense/${uuid}`);
}

export async function getByBillNumber(payload) {
  return request(`/iwms-wms/wms/sense/${payload.billNumber}/get?dcUuid=${payload.dcUuid}`);
}

export async function listSenseCheckBillItemByOrderBillNumber(payload) {
  return request(`/iwms-wms/wms/sense/listSenseCheckBillItemByOrderBillNumber?dcUuid=${payload.dcUuid}&orderBillNumber=${payload.orderBillNumber}`);
}


export async function finish(payload) {
  return request(`/iwms-wms/wms/sense/${payload.uuid}/finish?version=${payload.version}`, {
    method: 'POST'
  });
}